<template>
  <div class="contact-modal">
    <div class="modal-header">
      <span>添加</span>
      <i class="close" @click="cancel"></i>
    </div>
    <div class="modal-content">
      <FormItem
        v-for="(formItem, idx) in columns"
        :key="idx"
        :field="formItem"
        :form="formData"
        :disabled="disabled"
      ></FormItem>
    </div>
    <div class="modal-footer">
      <button class="cancel" @click="cancel">取消</button>
      <button class="confirm" @click="confirm">确定</button>
    </div>
  </div>
</template>

<script>
import FormItem from "@/components/FormItem";
export default {
  data() {
    return {
    }
  },
  props: {
    columns: {
      type: Array
    },
    formData: {
      type: Object
    },
    disabled: {
      default: false
    }
  },
  components: {
    FormItem
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      const newRow = {};
      for(let i = 0; i < this.columns.length; i++) {
        const key = this.columns[i].key;
        const field = this.formData[key];
        if (field instanceof Object === false) break;
        if (field.validate && !field.validate(field.value)) {
          return false;
        }
        newRow[key] = field.value;
        field.error = false;
      }
      this.$emit('confirm', newRow);
    }
  },

  mounted() {
  }
}
</script>

<style lang="less" scoped>
.contact-modal {
  width: 640px;
  background: #FFFFFF;
  padding: 30px 0;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.0600);

  .modal-header {
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url(../../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .modal-content {
    margin-bottom: 20px;

    .form-item {
      padding: 0 40px 0 56px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;

      &-label {
        width: 80px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262626;
        margin-right: 20px;
      }

      &-value {
        flex: 1;
        height: 46px;
        background: #F5F5F5;
        position: relative;

        .error-tip {
          position: absolute;
          left: 0;
          top: 100%;
          font-size: 12px;
          color: #FF3B2F;
          line-height: 20px;
          display: none;
        }

        &.error {
          border: 1px solid #FF3B2F;

          .error-tip {
            display: block;
          }
        }

        &.info {
          .error-tip {
            display: block;
            color: #06AE63;
          }
        }

        input {
          width: 80%;
          height: 100%;
          padding: 0 16px;
        }

        > select {
          width: 100%;
          height: 100%;
          border-radius: 2px;
          border: 1px solid #E6E7EB;
          outline: none;
          text-align: center;

          option {
            width: 41px;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #1B2841;
            line-height: 22px;
          }
        }
      }
    }

    hr {
      height: 1px;
      background: #EEEEEE;
      margin: 16px 0 20px 0;
    }

    .notice-tip {
      padding: 0 40px 0 56px;
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #787878;
      line-height: 24px;

      .icon-notice {
        width: 16px;
        height: 16px;
        display: block;
        margin-top: 4px;
        margin-right: 8px;
      }
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06AE63;
        background: rgba(6,174,99,0.1000);
      }

      &.confirm {
        background: #06AE63;
        color: #FFFFFF;
      }
    }
  }
}
</style>